import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/channel/';

function baseApi() {

    function insert(data, projectName) {
        return Post(baseUrl + 'insertImChannel', data, getProjectNameHeader(projectName));
    }

    function deleteData(data, projectName) {
        return Post(baseUrl + 'deleteImChannel', data, getProjectNameHeader(projectName));
    }

    function update(data, projectName) {
        return Post(baseUrl + 'updateImChannel', data, getProjectNameHeader(projectName));
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryImChannel', data, getProjectNameHeader(projectName));
    }

    return {
        insert, deleteData, update, query
    };
}

export const imChannelApi = baseApi();
